// Offertestatus: presentatie, geen domeinlogica (#459).
//
// De bron van de statuswaarden is StatusWorkflow in orion_core/status_workflow.py.
// De backend levert de status al in die canonieke spelling ('Concept', 'Verzonden',
// ...), ook voor oude rijen met 'CONCEPT' of 'VERZONDEN'. Deze helper spiegelt alleen
// de vijf waarden en vergelijkt zonder op hoofdletters of randwitruimte te letten,
// zodat een knop of dropdown niet stil uitvalt op een afwijkende spelling.

export const OFFERTE_STATUS = Object.freeze({
  CONCEPT: 'Concept',
  VERZONDEN: 'Verzonden',
  GEACCEPTEERD: 'Geaccepteerd',
  GEWEIGERD: 'Geweigerd',
  GEANNULEERD: 'Geannuleerd',
})

const PER_SLEUTEL = Object.fromEntries(
  Object.values(OFFERTE_STATUS).map((s) => [s.toLowerCase(), s])
)

/** Canonieke spelling van een status; onbekend blijft staan, leeg wordt null. */
export function offerteStatus(status) {
  const s = (status ?? '').toString().trim()
  if (!s) return null
  return PER_SLEUTEL[s.toLowerCase()] ?? s
}

/** Is `status` (in welke spelling ook) een van de gegeven canonieke statussen? */
export function isOfferteStatus(status, ...canoniek) {
  return canoniek.includes(offerteStatus(status))
}
